/* import __COLOCATED_TEMPLATE__ from './search-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();